export const P00039AntenneTypeEnum = [
  { ref: 0, label: 'P00039.antennetype.0' },
  { ref: 1, label: 'P00039.antennetype.1' },
];
